module.exports = __webpack_public_path__ + "fonts/VetoSans-Italic.1eaac834.woff";